import styled from "styled-components";

const SignupStyle = styled.div`
  height: 100%;
  background-color: rgb(76, 92, 150);
  background-color: rgb(46, 49, 65);
  background-image: linear-gradient(to top, #2c2c54, rgb(76, 92, 150));
  background-size: auto, cover;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  padding: 0 20px;
  align-items: center;
  align-content: center;
  justify-content: center;
  display: flex;
`;

export default SignupStyle;
